import { Logger } from '@aixuexi/tol-utils'
import dataTrack from './dataTrack'
import { getUserId } from '@/utils/tools'
import store from '@/store'
const institutionId = store.state.userInfo.userInfo.institutionId
console.log('institutionId', institutionId)

// const isDev = (!process.env.NODE_ENV || process.env.NODE_ENV === 'development')
// 会根据 setEnv.sh 文件中的 __ENV__ 来区分测试和生产环境
const logger = new Logger(dataTrack, true)
// 发送页面埋点
export function sendLogById(id, pp1 = {}) {
  if (!id) {
    return
  }
  const userId = getUserId()
  const data = {
    pd: dataTrack.pd, // 项目id
    pad: id, // 页面id
    uid: userId,
    pp1: {
      teacherId: userId,
      orgId: institutionId, // 机构id
      ...pp1
    }
  }
  logger.sendLog(data)
}
// 发送按钮埋点
export function sendLogClick(id, pp1 = {}) {
  if (!id) {
    return
  }
  const userId = getUserId()
  const data = {
    pp1: {
      teacherId: userId,
      orgId: institutionId, // 机构id
      ...pp1
    },
    aad: id,
    uid: userId
  }
  logger.sendAmcLog(data)
}
